import axios from './request'

const URL = {
  // 报价
  quotation: {
    retrieve: '/WHOLESALER-APP/quotation/myQuotationList.magpie',
    create: '/WHOLESALER-APP/quotation/add.magpie',
    detail: '/WHOLESALER-APP/quotation/detail.magpie',
    update: '/WHOLESALER-APP/quotation/update.magpie',
    cancel: '/WHOLESALER-APP/quotation/cancel.magpie',
    getVariety: '/MALLFACE/marketsituation/getVariety.magpie', // 获取商品类目/ 品种
    getVarietyAttr: '/MALLFACE/marketsituation/getVarietyAttr.magpie', // 获取品种动态属性
  },
  // 挂牌
  trade: {
    retrieve: '/WHOLESALER-APP/business/myTenderList.magpie',
    create: '/WHOLESALER-APP/business/tender.magpie',
    batchCreate: '/WHOLESALER-APP/business/batchTender.magpie',
    cancel: '/WHOLESALER-APP/business/tenderCancel.magpie',
    detail: '/WHOLESALER-APP/business/tenderDetail.magpie',
    adjustQuantity: '/WHOLESALER-APP/business/updateInventory.magpie',
  },
  // 摘牌
  order: {
    retrieve: '/WHOLESALER-APP/business/reservePageQuery.magpie',
    detail: '/WHOLESALER-APP/business/reserveDetail.magpie',
    confirmOrUpdateOrder: '/WHOLESALER-APP/business/reserveDealWith.magpie',

  },

  // 仓库
  warehouse: {
    retrieve: '/WRITE-OFF/warehouse/myWarehouse.magpie',
    create: '/WRITE-OFF/warehouse/add.magpie',
    update: '/WRITE-OFF/warehouse/update.magpie',
    delete: '/WRITE-OFF/warehouse/delete.magpie',
    detail: '/WRITE-OFF/warehouse/detail.magpie', // 没用这个接口  直接取的表格行数据
  },
  // 开店铺
  openStore: {
    create: '/WHOLESALER-APP/store/add.magpie',
    update: '/WHOLESALER-APP/store/update.magpie',
    detail: '/WHOLESALER-APP/store/myStoreDetail.magpie',
    getStoreDetailById: '/WHOLESALER-APP/store/detail.magpie',
    createContact: '/PCUSER-SERVICE/customerExtra/add.magpie', // 增加联系方式
    getContact: '/PCUSER-SERVICE/customerExtra/list.magpie', // 获取联系方式
    updateContact: '/PCUSER-SERVICE/customerExtra/edit.magpie', // 编辑联系方式
    deleteContact: '/PCUSER-SERVICE/customerExtra/delete.magpie', // 删除联系方式
    getBusinessInfo: '/WHOLESALER-APP/store/storeBusinessInfo.magpie', // 数据统计
  }
}
// 子系统管理
class MyStore {
  /**
   * 列表
   * @param {object} params
   */
  getQuotationData (param) {
    const url = URL.quotation.retrieve
    return axios.post(url, param)
  }
  /**
   * 获取品种
   * @param {string} marketCode 市场
   * @param {string} situationCode 场景
   */
  getVariety (marketCode, situationCode = 'DPGP') {
    const url = URL.quotation.getVariety
    return axios.post(url, { marketCode: '10606', situationCode })
  }
  /**
   * 获取品种动态属性
   * @param {string} marketCode 市场
   * @param {string} code 品种code
   * @param {string} situationCode 场景
   */
  getVarietyAttr (marketCode, code, situationCode = 'DPGP') {
    const url = URL.quotation.getVarietyAttr
    return axios.post(url, { marketCode: '10606', code, situationCode })
  }
  /**
   * 报价新增、编辑
   */
  createOrUpdateQuotation (param) {
    const url = param.id ? URL.quotation.update : URL.quotation.create
    return axios.post(url, param)
  }
  /**
   * 更新报价
   * @param {string} id 报价id
   * @param {string} priceType 报价类型
   * @param {string} priceList 价格列表
   */
  updateQuotation (param) {
    const url = URL.quotation.update
    return axios.post(url, param)
  }
  /**
   * 获取报价详情
   * @param {string} id 报价id
   */
  getQuotationDetail (id) {
    const url = URL.quotation.detail
    return axios.post(url, { id })
  }
  /**
   * 报价生效 失效
   * @param {string} id 报价id
   * @param {string} status 报价状态
   */
  setQuotationStatus (param) {
    const url = URL.quotation.cancel
    return axios.post(url, param)
  }
  /**
   * 挂牌分页列表
   */
  getTradeData (param) {
    const url = URL.trade.retrieve
    return axios.post(url, param)
  }
  /**
   * 挂牌详情
   * @param {string} id 挂牌id
   */
  getTradeDetail (id) {
    const url = URL.trade.detail
    return axios.post(url, { id })
  }
  /**
   * 发布挂牌
   */
  createTrade (param) {
    const url = URL.trade.create
    return axios.post(url, param)
  }
  /**
   * 批量发布挂牌
   */
  batchCreateTrade (param) {
    const url = URL.trade.batchCreate
    return axios.post(url, param)
  }
  /**
   * 下架挂牌
   */
  cancelTrade (id) {
    const url = URL.trade.cancel
    const param = { id }
    return axios.post(url, param)
  }
  /**
   * 调整库存
   */
  adjustQuantity (param) {
    const url = URL.trade.adjustQuantity
    return axios.post(url, param)
  }
  /**
   * 订单/摘牌分页列表
   */
  getOrderData (param) {
    const url = URL.order.retrieve
    return axios.post(url, param)
  }
  /**
  * 摘牌详情
  * @param {string} id 挂牌id
  */
  getOrderDetail (id) {
    const url = URL.order.detail
    return axios.post(url, { id })
  }
  /**
   * 编辑意向单/确认意向单
   */
  confirmOrUpdateOrder (param) {
    const url = URL.order.confirmOrUpdateOrder
    return axios.post(url, param)
  }
  /**
   * 仓库列表
   */
  getWarehouseData (param) {
    const url = URL.warehouse.retrieve
    return axios.post(url, { ...param, warehouseType: 'WHOLESALER_APP' })
  }
  /**
   * 仓库新增、编辑
   */
  createOrUpdateWarehouse (param) {
    const url = param.id ? URL.warehouse.update : URL.warehouse.create
    return axios.post(url, param)
  }
  /**
   * 仓库详情
   */
  getWarehouseDetail (id) {
    const url = URL.warehouse.detail
    const param = { id }
    return axios.post(url, param)
  }
  /**
   * 仓库删除
   */
  deleteWarehouse (id) {
    const url = URL.warehouse.delete
    const param = { id }
    return axios.post(url, param)
  }
  /**
   * 新增店铺
   */
  createStore (param) {
    const url = URL.openStore.create
    return axios.post(url, param)
  }
  /**
   * 更新店铺
   */
  updateStroe (param) {
    const url = URL.openStore.update
    return axios.post(url, param)
  }
  /**
   * 店铺详情
   */
  getStoreDetail () {
    const url = URL.openStore.detail
    return axios.post(url)
  }
  /**
   * 根据id获取店铺详情
   */
  getStoreDetailById (id) {
    const url = URL.openStore.getStoreDetailById
    return axios.post(url, { id })
  }
  /**
   * 新增联系方式
   */
  createContact (param) {
    const url = URL.openStore.createContact
    return axios.post(url, param)
  }
  /**
   * 获取联系方式
   * @param {string} objectId 用户id
   */
  getContact (objectId, type = 'CONTACT', represent = 'SHOP_MOBILE') {
    const url = URL.openStore.getContact
    return axios.post(url, { objectId, type, represent })
  }
  /**
   * 编辑联系方式
   */
  updateContact (param) {
    const url = URL.openStore.updateContact
    return axios.post(url, param)
  }
  /**
   * 删除联系方式
   */
  deleteContact (id) {
    const url = URL.openStore.deleteContact
    return axios.post(url, { id })
  }
  /**
   * 店铺统计信息
   */
  getBusinessInfo (param) {
    const url = URL.openStore.getBusinessInfo
    return axios.post(url, param)
  }
}

export default new MyStore()
